/**
 * @ngdoc controllers
 * @memberof mercury.modules.settings
 * @name SettingsCompanyAcceptOwnershipCtrl
 */
angular.module('mercury.modules.settings.company')
.controller('SettingsCompanyAcceptOwnershipCtrl', ["Company", "$scope", "$state", "$stateParams", "title", "userinfo", function(Company, $scope, $state, $stateParams, title, userinfo) {

  userinfo.activeCompany($stateParams.id);

  // check that the invite is still valid
  $scope.loading = Company.get($stateParams.id);
  $scope.loading.then(function(result) {
    console.log(result);
    $scope.company = result;
    $scope.canTakeOwnership = $scope.company.pendingOwnerId == userinfo.userDetails().id &&
      userinfo.companyHasPermission('Manager', $stateParams.id);
    // console.log($scope.company.pendingOwnerId);
    // console.log(userinfo.userDetails());
    // console.log(userinfo.companyHasPermission('Manager', $stateParams.id));
    // console.log('canTakeOwnership: ');
    // console.log($scope.canTakeOwnership);
  });

  $scope.acceptOwnership = function(accepts) {
    $scope.loading = Company.acceptTransfer($scope.company.id, userinfo.userDetails().id, accepts);
    $scope.loading.then(function() {
      $state.go('Settings.CompanyEdit', {id: $scope.company.id}, {reload: true});
    });
  };

  $scope.errorAccept = function() {
    $state.go('Settings.CompanyEdit', {id: $scope.company.id}, {reload: true});
  };

}]);
